import React, { useState, useEffect, useRef } from "react";

import * as styles from "./FeaturedListBlock.module.scss";
import { RichText } from "../RichText/RichText";
import { GatsbyImage } from "gatsby-plugin-image";


const FeaturedListBlock = ({ info, sectionTitle, sectionParagraph, image }) => {


    return (
        <section className={`${styles.mainContainer} c-padding`}>
            <div className={`container ${styles.informationContainer}`}>
                <div className={styles.informationText}>
                    <h2 className="global-spacing-bottom">{sectionTitle}</h2>
                    {/* {sectionParagraph && (
                        <RichText content={sectionParagraph} />
                    )

                    } */}
                    <GatsbyImage
                        image={image.gatsbyImageData}
                        alt={image.title}
                        loading="lazy"
                        className={styles.infoImage}
                    />

                </div>
                <div className={styles.informationList}>
                    {info?.map((info, index) => {

                        return (
                            <div
                                key={index}
                                className={styles.informationItem}
                                role="button"
                                tabIndex={0}
                            >
                                <h3>
                                    {info.title}
                                </h3>
                                <div
                                    className={`${styles.answer}`}
                                    style={{ overflow: "hidden" }}
                                    role="region"
                                >
                                    <RichText content={info.description} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FeaturedListBlock;
